import { render, staticRenderFns } from "./HomeNext.vue?vue&type=template&id=28c8c5e4&scoped=true"
import script from "./HomeNext.vue?vue&type=script&lang=js"
export * from "./HomeNext.vue?vue&type=script&lang=js"
import style0 from "./HomeNext.vue?vue&type=style&index=0&id=28c8c5e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c8c5e4",
  null
  
)

export default component.exports